var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"form-title font-medium text-2xl"},[_vm._v(_vm._s(_vm.form.title))]),_c('p',{staticClass:"form-description mt-2"},[_vm._v(_vm._s(_vm.form.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }